module.exports = __webpack_public_path__ + "static/media/404_pnf.583bb888.svg";